import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RestResponse } from '../../../shared/RestResponse';
import { Pagination } from '../../../shared/Pagination';
import { ListUserDto } from '../../users/dto/listUserDto';
import { UserService } from '../../users/userService';

@Component({
  selector: 'app-list-customer',
  templateUrl: './list-customer.html',
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, InputTextModule, TagModule, TooltipModule, SelectModule, ConfirmDialogModule]
})
export class ListCustomerComponent implements OnInit {
  Customers: ListUserDto[] = [];
  search: string = '';
  searchTerm: string = '';
  active: boolean | null = null;
  canRequestRide: boolean | null = null;

  constructor(
    private CustomerService: UserService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.loadCustomers();
  }

  loadCustomers(): void {
    this.CustomerService.list(this.search, 1, this.active, this.canRequestRide, undefined, [3]).subscribe((response: RestResponse<ListUserDto[]>) => {
      this.Customers = response.data;
    });
  }

  onSearchChange(search: string): void {
    this.search = search;
    this.loadCustomers();
  }

  onActiveChange(active: boolean | null): void {
    this.active = active;
    this.loadCustomers();
  }

  onCanRequestRideChange(canRequestRide: boolean | null): void {
    this.canRequestRide = canRequestRide;
    this.loadCustomers();
  }

  clearFilters(): void {
    this.search = '';
    this.searchTerm = '';
    this.active = null;
    this.canRequestRide = null;
    this.loadCustomers();
  }

  editCustomer(id: number): void {
    this.router.navigate(['/customers/edit', id]);
  }

  deleteCustomer(id: number): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir este usuário?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.CustomerService.delete(id).subscribe({
          next: () => {
            this.loadCustomers();
          },
          error: (error) => {
            console.error('Erro ao excluir usuário:', error);
          }
        });
      }
    });
  }

  navigateToCreate(): void {
    this.router.navigate(['/customers/create']);
  }
}
